




































































































































import { get } from 'lodash';
import { User } from '@/types/GlobalTypes';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';

export default {
    name: 'CoPeople',
    components: {
        CoThumbnail,
        CoSkeleton,
        CoText,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
            required: false,
        },
        people: {
            type: Array as () => User[],
            required: false,
            default: () => [],
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['xs', 'sm', 'ms', 'md', 'lg', 'xl'].includes(value),
        },
        limit: {
            type: Number,
            default: 3,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
        showTotalCount: {
            type: Boolean,
            default: false,
        },
        allowShowAll: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        restCount(): string {
            let count = this.totalCount;

            if (count < 0) {
                count = 0;
                return '0';
            }

            if (count > 999) {
                // conver to K format 1000 -> 1K, 1500 -> 1.5K, 10000 -> 10K, 10500 -> 10.5K, 100000 -> 100K, 999999 -> 999.9K
                count = Math.floor(count / 100) / 10;
                return `${count}k`;
            }

            return `${count}`;
        },
    },
    methods: {
        get,
        clickOnMore() {
            this.$emit('show-all');
        },
    },
};
